import {
  DELETE_SERVICE_KEY_SUCCESS,
  GET_ALL_SERVICE_KEYS_SUCCESS,
  LOGOUT_COMPLETE,
} from 'js/constants/actionTypes';

const initialState = {
  sortedIds: [],
  lastUpdated: null,
};

export const serviceKeysReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SERVICE_KEYS_SUCCESS:
      return saveServiceKey(state, action);

    case DELETE_SERVICE_KEY_SUCCESS:
      return deleteServiceKey(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function saveServiceKey(state, action) {
  const { entities } = action;
  const { serviceKeys = [] } = entities;

  const descOrderID = Object.values(serviceKeys)
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((i) => i.id);

  return {
    ...state,
    sortedIds: descOrderID,
    lastUpdated: action.receivedAt,
  };
}

function deleteServiceKey(state, action) {
  const {
    requestInfo: { id: deletedId },
  } = action;
  const { sortedIds } = state;
  const newSortedIds = sortedIds.filter((id) => id !== deletedId);

  return {
    ...state,
    lastUpdated: action.receivedAt,
    sortedIds: newSortedIds,
  };
}
